import React from 'react';
import { plansApi } from '../api/plansApi';

function pickErrMsg(e) {
  return (
    e?.response?.data?.message || e?.response?.data?.error || e?.message || 'Beklenmeyen hata.'
  );
}

export function usePlans({ open }) {
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [items, setItems] = React.useState([]);

  const fetchList = React.useCallback(async () => {
    try {
      setErr(null);
      setLoading(true);
      const res = await plansApi.list();
      setItems(Array.isArray(res) ? res : []);
    } catch (e) {
      console.error(e);
      setErr(pickErrMsg(e));
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (!open) return;
    fetchList();
  }, [open, fetchList]);

  const create = React.useCallback(async (payload) => {
    return plansApi.create(payload);
  }, []);

  const update = React.useCallback(async (id, payload) => {
    return plansApi.update(id, payload);
  }, []);

  const setActive = React.useCallback(async (id, active) => {
    return plansApi.setActive(id, active);
  }, []);

  return { loading, err, items, fetchList, create, update, setActive };
}
